import React from "react";
import Overlay from "../../components/common/Overlay";
import { PaymentButtonsProps, PaymentModal } from "./PaymentButtons";
import { useReservationResources } from "./hooks/useReservationResources";

interface PaymentOverlayProps extends PaymentButtonsProps {
  isOpen: boolean;
  onClose: () => void;
  paymentModalKey: number;
  isUnder900: boolean;
}

export function PaymentOverlay({
  isOpen,
  onClose,
  paymentModalKey,
  isUnder900,
  ...paymentProps
}: PaymentOverlayProps) {
  const r = useReservationResources();
  if (!isUnder900) return null;
  return (
    <Overlay
      handleClose={onClose}
      open={isOpen}
      size="sm"
      id="payment-modal"
      titleText={r.PaymentOptions}
    >
      <PaymentModal key={paymentModalKey} {...paymentProps} />
    </Overlay>
  );
}
